import script from "./DataView.vue?vue&type=script&setup=true&lang=js"
export * from "./DataView.vue?vue&type=script&setup=true&lang=js"

import "./DataView.vue?vue&type=style&index=0&id=fec1474a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fec1474a"]])

export default __exports__